"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOfflineSnackbars = exports.ODRSnackbars = void 0;
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const ODROfflineCrossSectionsSnackbar_1 = require("../molecules/ODROfflineCrossSectionsSnackbar");
const ODROfflineLibraryResourceSnackbar_1 = require("../molecules/ODROfflineLibraryResourceSnackbar");
const ODROfflineModelSnackbar_1 = require("../molecules/ODROfflineModelSnackbar");
const ODROfflineRadiologyResourceSnackbar_1 = require("../molecules/ODROfflineRadiologyResourceSnackbar");
const ODROfflineStructureSnackbar_1 = require("../molecules/ODROfflineStructureSnackbar");
var ODRSnackbars;
(function (ODRSnackbars) {
    ODRSnackbars["OfflineCrossSectionsSnackbar"] = "ODROfflineCrossSectionsSnackbar";
    ODRSnackbars["OfflineLibraryResourceSnackbar"] = "ODROfflineLibraryResourceSnackbar";
    ODRSnackbars["OfflineModelSnackbar"] = "ODROfflineModelSnackbar";
    ODRSnackbars["OfflineRadiologyResourceSnackbar"] = "ODROfflineRadiologyResourceSnackbar";
    ODRSnackbars["OfflineStructureSnackbar"] = "ODROfflineStructureSnackbar";
})(ODRSnackbars || (exports.ODRSnackbars = ODRSnackbars = {}));
function useOfflineSnackbars() {
    const { register, unregister, show: showSnackbar } = (0, ui_1.useSnackbar)();
    (0, react_1.useEffect)(() => {
        register(ODRSnackbars.OfflineCrossSectionsSnackbar, ODROfflineCrossSectionsSnackbar_1.ODROfflineCrossSectionsSnackbar);
        register(ODRSnackbars.OfflineLibraryResourceSnackbar, ODROfflineLibraryResourceSnackbar_1.ODROfflineLibraryResourceSnackbar);
        register(ODRSnackbars.OfflineModelSnackbar, ODROfflineModelSnackbar_1.ODROfflineModelSnackbar);
        register(ODRSnackbars.OfflineRadiologyResourceSnackbar, ODROfflineRadiologyResourceSnackbar_1.ODROfflineRadiologyResourceSnackbar);
        register(ODRSnackbars.OfflineStructureSnackbar, ODROfflineStructureSnackbar_1.ODROfflineStructureSnackbar);
        return () => {
            unregister(ODRSnackbars.OfflineCrossSectionsSnackbar);
            unregister(ODRSnackbars.OfflineLibraryResourceSnackbar);
            unregister(ODRSnackbars.OfflineModelSnackbar);
            unregister(ODRSnackbars.OfflineRadiologyResourceSnackbar);
            unregister(ODRSnackbars.OfflineStructureSnackbar);
        };
    }, [register, unregister]);
    const show = (showMessage) => {
        switch (showMessage) {
            case ODRSnackbars.OfflineCrossSectionsSnackbar:
                return showSnackbar(ODRSnackbars.OfflineCrossSectionsSnackbar);
            case ODRSnackbars.OfflineLibraryResourceSnackbar:
                return showSnackbar(ODRSnackbars.OfflineLibraryResourceSnackbar);
            case ODRSnackbars.OfflineModelSnackbar:
                return showSnackbar(ODRSnackbars.OfflineModelSnackbar);
            case ODRSnackbars.OfflineRadiologyResourceSnackbar:
                return showSnackbar(ODRSnackbars.OfflineRadiologyResourceSnackbar);
            case ODRSnackbars.OfflineStructureSnackbar:
                return showSnackbar(ODRSnackbars.OfflineStructureSnackbar);
        }
    };
    return { show };
}
exports.useOfflineSnackbars = useOfflineSnackbars;
